module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "OT"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "CON1"
  }, [_c('a', {
    attrs: {
      "href": "#/CoverImage"
    }
  }, [_vm._v("Cover")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Mouw_Called_to_the_Life_of_the_Mind_text_CC4#_idTOCAnchor-21"
    }
  }, [_vm._v("1. The Price")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Mouw_Called_to_the_Life_of_the_Mind_text_CC5#_idTOCAnchor-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Accusing Voices")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Mouw_Called_to_the_Life_of_the_Mind_text_CC6#_idTOCAnchor-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. The Value Question")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Mouw_Called_to_the_Life_of_the_Mind_text_CC7#_idTOCAnchor-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. The Need for Calisthenics")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Mouw_Called_to_the_Life_of_the_Mind_text_CC8#_idTOCAnchor-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Not Too Much Haste")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Mouw_Called_to_the_Life_of_the_Mind_text_CC9#_idTOCAnchor-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. The Disillusionment")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Mouw_Called_to_the_Life_of_the_Mind_text_CC10#_idTOCAnchor-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Humility and Hope")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Mouw_Called_to_the_Life_of_the_Mind_text_CC11#_idTOCAnchor-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Navigating the “Square Inches”")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Mouw_Called_to_the_Life_of_the_Mind_text_CC12#_idTOCAnchor-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. A Communal Task")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Mouw_Called_to_the_Life_of_the_Mind_text_CC13#_idTOCAnchor-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Mutual Encouragement")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Mouw_Called_to_the_Life_of_the_Mind_text_CC14#_idTOCAnchor-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Safe Spaces for “Playing Around”")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Mouw_Called_to_the_Life_of_the_Mind_text_CC15#_idTOCAnchor-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. Academic “Body Life”")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Mouw_Called_to_the_Life_of_the_Mind_text_CC16#_idTOCAnchor-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. Academic “Hopes and Fears”")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Mouw_Called_to_the_Life_of_the_Mind_text_CC17#_idTOCAnchor-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. Critique as a “Moment”")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Mouw_Called_to_the_Life_of_the_Mind_text_CC18#_idTOCAnchor-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. Reality Lovers")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Mouw_Called_to_the_Life_of_the_Mind_text_CC19#_idTOCAnchor-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. Honoring Creation")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Mouw_Called_to_the_Life_of_the_Mind_text_CC20#_idTOCAnchor-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. Beholders")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Mouw_Called_to_the_Life_of_the_Mind_text_CC21#_idTOCAnchor-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. Being Like Jesus in the Academy")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Mouw_Called_to_the_Life_of_the_Mind_text_CC22#_idTOCAnchor-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. A Loom for Weaving")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Mouw_Called_to_the_Life_of_the_Mind_text_CC23#_idTOCAnchor-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Endnotes")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54f6be62","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Mouw_Called_to_the_Life_of_the_Mind_text_CC3.vue
// module id = 63
// module chunks = 0